import React, {useEffect, useState} from "react";
import {Accordion, AccordionSummary, AccordionDetails, Typography, CircularProgress} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {GetConflictingEntraIdUsers} from "../../api/endpoints";
import apiClient from "../../api/apiClient";
import StyledDataGrid from "../common/StyledDataGrid";

interface EntraIdConflictingUsersCardProps {
    marginTop: string;
    marginBottom: string;
}

interface ConflictingEntraIdUsersDto {
    userId: string;
    displayName: string;
    name: string;
    surname: string;
    email: string | null;
    phone: string | null;
    departmentId: string | null;
    jobTitle: string | null;
    employeeId: string | null;
    error: string | null;
}

const columns = [
    {field: "userId", headerName: "User ID", flex: 1},
    {field: "errorText", headerName: "Feilkode", flex: 1},
    {field: "displayName", headerName: "Display Name", flex: 1},
    {field: "name", headerName: "First name", flex: 1},
    {field: "surname", headerName: "Last name", flex: 1},
    {field: "email", headerName: "Email", flex: 1},
    {field: "phone", headerName: "Mobile phone", flex: 1},
    // {field: "employeeId", headerName: "Employee ID", flex: 1},
    {field: "departmentId", headerName: "Department", flex: 1},
    {field: "jobTitle", headerName: "Job title", flex: 1},
];

const EntraIdConflictingUsersCard: React.FC<EntraIdConflictingUsersCardProps> = ({
                                                                                     marginTop = "16px",
                                                                                     marginBottom = "16px"
                                                                                 }) => {
    const [loading, setLoading] = useState(true);
    const [users, setUsers] = useState<ConflictingEntraIdUsersDto[]>([]);
    const [error, setError] = useState<string | null>(null);

    // Fetch data when component mounts
    useEffect(() => {
        const fetchConflictingUsers = async () => {
            try {
                setLoading(true);
                setError(null);

                const response = await apiClient.get(GetConflictingEntraIdUsers); // Replace with your API endpoint
                const corruptedUsers = (await response.data.data ?? []).map((u: ConflictingEntraIdUsersDto) => ({
                    id: u.userId,  // <-- DataGrid needs this
                    errorText: (u.error === "0") ? "Konflikt med eksisterende bruker" : "Mangler informasjon",
                    ...u
                }));
                setUsers(corruptedUsers);
                setUsers(corruptedUsers ?? []);

            } catch (err: any) {
                console.log(err);
                if (err.response) {
                    // Backend responded with an error (4xx, 5xx)
                    setError(`${err.response.status} ${err.response.data?.message ?? ""}`);
                } else if (err.request) {
                    // Request was sent but NO response received (timeout, offline, CORS, etc.)
                    setError("Server did not respond. Please try again later.");
                } else {
                    // Something else happened before request was sent
                    setError(err.message || "Unknown error");
                }
            } finally {
                setLoading(false);
            }
        };

        fetchConflictingUsers();
    }, []);


    return (
        <div style={{marginTop, marginBottom}}>
            {loading ? (
                <Accordion sx={{width: "100%"}} disabled={true}>
                    <AccordionSummary>
                        <CircularProgress size={24} style={{marginRight: 16}}/>
                        <Typography fontWeight={600}>
                            Ser etter brukere med konflikter
                        </Typography>
                    </AccordionSummary>
                </Accordion>
            ) : (
                <Accordion sx={{width: "100%"}}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                        <Typography fontWeight={600}>Brukere med konflikter</Typography>
                    </AccordionSummary>

                    <AccordionDetails>
                        {error && (
                            <Typography color="error">
                                {error}
                            </Typography>
                        )}

                        {!error && users.length > 0 && (
                            <StyledDataGrid
                                rows={users}
                                columns={columns}
                                loading={false}
                                onRowClick={(row) => console.log("Clicked:", row.id)}
                            />
                        )}

                        {!error && users.length === 0 && (
                            <Typography>Ingen konflikter 🎉</Typography>
                        )}
                    </AccordionDetails>
                </Accordion>
            )}
        </div>
    )
        ;
};

export default EntraIdConflictingUsersCard;